import { render, staticRenderFns } from "./crateMovements.vue?vue&type=template&id=270fc0a9"
import script from "./crateMovements.vue?vue&type=script&lang=js"
export * from "./crateMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports